import { Injectable } from '@angular/core';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { HttpClientWrapper } from '~/services/api/httpClientWrapper';
import { BaseWebService } from '~/services/api/web/base/baseWebService';
import { ResponseModel } from '~/models/responseModel';
import { Observable } from 'rxjs';
import { map as _map } from 'lodash';
import { ServerPaginationModel } from '~/models/serverPagination/serverPaginationModel';
import { OrderSummaryModel } from '~/models/orderSummaryModel';
import { ServerFilterModel } from '~/models/serverPagination/serverFilterModel';

@Injectable()
export class OrderService extends BaseWebService {

    public static readonly PATH: string = '/order';

    constructor(http: HttpClientWrapper) {
        super(http);
    }


    public searchOrders(searchModel?: ServerPaginationModel<OrderSummaryModel>): Observable<ResponseModel> {
        let url:string = OrderService.URL + OrderService.PATH + '/search';
        let body:any = searchModel;
        let options:{} = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          };
          
        return this.http.post(url, body, options, (response: HttpResponse<any>) => {
            return new ServerPaginationModel<OrderSummaryModel>(OrderSummaryModel, response['data']);
        });
    }

    public getLotFilters(filter?: ServerFilterModel): Observable<ResponseModel> {
        let url:string = OrderService.URL + OrderService.PATH + '/filters';
        let body:any = filter;
        let options:{} = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          };

        return this.http.post(url, body, options, (response: HttpResponse<any>) => {
            return response['data'];
        });
    }

}
